import React from 'react';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';

const DEFAULT_ALLOWED_TAGS = ['b', 'i', 'u', 'em', 'strong', 'br', 'p', 'ul', 'ol', 'li'];

const SafeHTML = ({ html, allowedTags, className }) => {
  const clean = DOMPurify.sanitize(html ?? '', {
    ALLOWED_TAGS: allowedTags ?? DEFAULT_ALLOWED_TAGS,
    ALLOWED_ATTR: [],
  });
  return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
};

SafeHTML.propTypes = {
  html: PropTypes.string,
  allowedTags: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
};

export default SafeHTML;
